<div class="absolute inset-0 z-40 bg-black opacity-50"></div>
<div class="absolute inset-0 z-40 grid place-items-center px-4 pb-6 md:p-0">
  <div class="grid w-[calc(100vw_-_32px)] max-w-[500px] rounded-3xl bg-white p-4 md:w-auto">
    <ng-content></ng-content>
    <button app-button translate (click)="closeModal.emit()">btn.gotIt</button>
  </div>
</div>
